module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/pm-icon-37039d7d40f2dc7ab3d340772d505b33.png";